const ALERT = {
  TYPE: {
    ERROR: 'error',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning'
  },
  TIMEOUT: {
    DEFAULT: 1500,
    MEDIUM: 1800,
    LONG: 5000,
    VERY_LONG: 60000
  }
};

const ERROR_CODE = {
  INVALID_HASH: '0007',
  BLOCKING_QUIZ: '0058',
  BLOCKING_QUIZ_BULK: '0058_BULK'
};

const ERRORS = {
  '0001': 'invalid_parameter',
  '0002': 'feature_disabled',
  '0003': 'paid_module_cannot_be_deleted_when_there_are_buyers',
  '0006': 'entity_not_found',
  [ERROR_CODE.INVALID_HASH]: 'invalid_hash',
  '0008': 'search_article_info_failed',
  '0009': 'paid_module_not_allowed_for_subscription_product',
  '0010': 'invalid_paid_module_configuration',
  '0011': 'public_module_not_allowed_for_content_with_streaming_file',
  '0012': 'create_suboffer_failed',
  '0013': 'update_suboffer_failed',
  '0014': 'load_suboffer_failed',
  '0015': 'invalid_hot_pass_cost_config',
  '0020': 'invalid_selected_offers',
  '0027': 'config.data.not_verified_domain',
  '0028': 'can_not_delete_class_with_users',
  '0050': 'modules_must_belong_to_at_least_one_class',
  [ERROR_CODE.BLOCKING_QUIZ]: 'blocking_quiz',
  [ERROR_CODE.BLOCKING_QUIZ_BULK]: 'blocking_quiz_bulk',
  '9001': 'required_at_last_one',
  '9002': 'precondition_failed',
  '9003': 'parameter_required',
  '9007': 'password.invalid',
  '9999': 'unexpected_error'
};

const GRID_SIZE_TYPE = {
  NOTEBOOK: 1333,
  IPAD: 1024
};

export { ALERT, ERRORS, ERROR_CODE, GRID_SIZE_TYPE };
